import { api } from "../lib/api";

export const exportData = () =>
  api.get("/me/export", { responseType: "blob" }).then((r) => r.data);

export const deleteAccount = () => api.delete("/me").then((r) => r.data);
